// ============================================================
// PRODUCT GALLERY — show all colour images & scroll on swatch
// ============================================================
document.addEventListener('DOMContentLoaded', () => {

  // -- 1. Remove [hidden] from all gallery media & watch for re-hiding --
  const gallery = document.querySelector('product-gallery');
  if (gallery) {
    const revealAll = () => {
      gallery.querySelectorAll('.product-gallery__media[hidden]').forEach(el => {
        el.removeAttribute('hidden');
      });
    };

    setTimeout(revealAll, 500);

    new MutationObserver(revealAll).observe(gallery, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden']
    });
  }

  // -- 2. Scroll to correct colour image on swatch change --
  const scrollToColour = (colour) => {
    const items = [...document.querySelectorAll('.product-gallery__media')];
    const target = items.find(item => {
      const alt = item.querySelector('img')?.getAttribute('alt') || '';
      return alt.toLowerCase().includes(`--colour_${colour}`);
    });

    if (!target) return;

    const carousel = document.querySelector('scroll-carousel, .product-gallery__carousel');
    const isMobileCarousel = carousel && carousel.scrollWidth > carousel.clientWidth;

    if (isMobileCarousel) {
      const carouselRect = carousel.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const scrollLeft = carousel.scrollLeft + (targetRect.left - carouselRect.left);
      carousel.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    } else {
      const rect = target.getBoundingClientRect();
      const scrollTop = window.scrollY + rect.top - 100;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  };

  let ready = false;
  setTimeout(() => { ready = true; }, 2000);

  document.addEventListener('change', (e) => {
    if (!ready) return;
    const form = e.target.closest('form[id*="product-form"]');
    if (!form) return;

    setTimeout(() => {
      const variantId = form.querySelector('input[name="id"]')?.value;
      const productHandle = document.querySelector('variant-picker')?.getAttribute('handle');
      if (!productHandle || !variantId) return;

      fetch(`/products/${productHandle}.js`)
        .then(r => r.json())
        .then(product => {
          const variant = product.variants.find(v => v.id == variantId);
          if (!variant) return;
          const colour = variant.option3?.toLowerCase();
          if (colour) scrollToColour(colour);
        });
    }, 300);
  });

});

// ============================================================
// MOBILE SIDEBAR — tap title to navigate, tap chevron to expand
// ============================================================
document.addEventListener('click', (e) => {
  const button = e.target.closest('.header-sidebar__linklist-button');
  if (!button || button.tagName !== 'BUTTON') return;

  const panelId = button.getAttribute('aria-controls');
  if (!panelId) return;

  const sidebar = button.closest('header-sidebar');
  if (!sidebar) return;

  const href = button.dataset.href;
  if (!href || href === '#' || href === 'javascript:void(0)') return;

  const rect = button.getBoundingClientRect();
  const chevronZone = rect.right - 40;
  if (e.clientX >= chevronZone) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  window.location.href = href;
});
function fixCollectionGridMobile() {
  if (window.innerWidth <= 749) {
    const carousel = document.querySelector(
      '#shopify-section-template--22412912099557__collection_list_rraXBy scroll-carousel.collection-list'
    );
    if (!carousel) return;

    // Remove inline styles set by the carousel JS
    carousel.removeAttribute('style');

    carousel.querySelectorAll('.collection-list__item').forEach(item => {
      item.removeAttribute('style');
    });
  }
}

// Run on load and on resize
document.addEventListener('DOMContentLoaded', fixCollectionGridMobile);
window.addEventListener('resize', fixCollectionGridMobile);
